// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"0ecfeceb","372":"1fb49acc","488":"768a8152","849":"999b7e07"}[chunkId] + ".chunk.js";
};